import * as actions from 'actions/types';

export default function(state = null, action) {
  switch (action.type) {
    case actions.INIT_WIZARD:
      return action.payload;
    case actions.SAVE_WIZARD:
    case actions.SUBMIT_WIZARD:
    case actions.SUBMIT_WIZARD_STEP:
    case actions.CHANGE_WIZARD_STEP:
      return { ...state, ...action.payload };
    case actions.CLEAR_WIZARD:
      return null;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/wizard.js